import { Fake } from "../skeleton/Fake";
import { SearchEventAndOrganisationContainer } from "components/layout/home/SearchEventAndOrganisationContainer";
import { EventCard } from "components/routes/root/eventCard/EventCard";
import { EventCardMainSection } from "components/routes/root/eventCard/EventCardMainSection";
import { Stack, Typography } from "@mui/material";
import { EventCardDetailsSection } from "components/routes/root/eventCard/EventCardDetailsSection";

export const SearchEventAndOrganisationResultsSkeleton = () => {
    return (
        <div role="status" aria-label="loading" className="skeleton">
            <SearchEventAndOrganisationContainer>
                {[...new Array(3)].map((_, key) => (
                    <EventCard key={key} fullWidth>
                        <EventCardMainSection mb={0.125}>
                            <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="space-between"
                            >
                                <Typography variant="label2">
                                    <Fake size={28} />
                                </Typography>
                                <Typography variant="body">
                                    <Fake size={16} />
                                </Typography>
                            </Stack>
                            <Typography variant="h7">
                                <Fake size={42} />
                            </Typography>
                        </EventCardMainSection>
                        <EventCardDetailsSection>
                            <Typography
                                variant="h4"
                                py={0.125}
                                sx={{
                                    borderRadius: "100%",
                                    overflow: "hidden",
                                }}
                            >
                                <Fake size={7} />
                            </Typography>
                        </EventCardDetailsSection>
                    </EventCard>
                ))}
            </SearchEventAndOrganisationContainer>
        </div>
    );
};
